import { useMemo, useState } from 'react';
import { useCourses } from 'v4/lib/hooks/use-courses';
import { CustomDropdown } from '../custom-dropdown';

export const CoursesDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();

  const { data, createLoading, mutateAsync, isLoading } = useCourses({
    search,
  });

  const courses = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  return (
    <CustomDropdown
      {...props}
      data={courses}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
    />
  );
};
